import { render, staticRenderFns } from "./WeedCardList.vue?vue&type=template&id=764d5d4e"
import script from "./WeedCardList.vue?vue&type=script&lang=js"
export * from "./WeedCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports